var map = {
	"./alpine-car.webp": 29419,
	"./aprilia-car.webp": 69980,
	"./aston-martin-car.webp": 19559,
	"./audi-car.webp": 58857,
	"./ducati-car.webp": 2068,
	"./ferrari-car.webp": 6403,
	"./gresini-car.webp": 96031,
	"./haas-car.webp": 65931,
	"./honda-car.webp": 6632,
	"./kick-sauber-car.webp": 44691,
	"./ktm-car.webp": 85880,
	"./mclaren-car.webp": 70954,
	"./mercedes-car.webp": 56872,
	"./pertamina-enduro-car.webp": 42441,
	"./prima-pramac-car.webp": 59878,
	"./rb-car.webp": 5872,
	"./red-bull-car.webp": 16827,
	"./redbull-gasgas-car.webp": 13635,
	"./repsol-honda-car.webp": 63568,
	"./trackhouse-car.webp": 12238,
	"./williams-car.webp": 9822,
	"./yamaha-car.webp": 10347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69247;